import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import {api as axios} from '../../../shared/axios';
import { API_URL } from '../../../shared/config';
import WidgetLoading from '../../../components/ui/WidgetLoading';

const NTSSO = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const getTokenFromParams = () => {
    const params = Array.from(searchParams.entries());
    const tcodeParam = params.find(([key]) => key.toLowerCase() === 'tcode');
    if (tcodeParam) return tcodeParam[1];
    const nttokenParam = params.find(([key]) => key.toLowerCase() === 'nttoken');
    if (nttokenParam) return nttokenParam[1];
    return null;
  };
  
  const tokenFromUrl = getTokenFromParams();

  useEffect(() => {
    if (tokenFromUrl) {
      handleFraserSignIn();
    }
  }, [tokenFromUrl]);

  const handleFraserSignIn = async() => {
    if (!tokenFromUrl) {
      setError('No token found in URL. Please provide a valid token parameter.');
      return;
    }
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await axios.post(`${API_URL}/account/social/nt/`, {
        access_token: tokenFromUrl
      });

      console.log('NTSSO - Authentication successful:', response);
      
      setSuccess(true);
      
      setTimeout(() => {
        localStorage.removeItem("ftk");
        navigate("/");
      }, 2000);
      
    } catch (err) {
      setError(`API Error: ${err.response?.status} - ${err.response?.data?.message || err.message}`);
      setTimeout(() => {
        navigate("/login");
      }, 5000);
      
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="flex flex-col justify-center items-center p-6 min-h-screen">
      {isLoading ? (
        <WidgetLoading text="Authenticating with NT SSO..." />
      ) : (
        <div className="p-8 w-full max-w-md bg-white rounded-lg shadow-lg">
          <h2 className="mb-6 text-2xl font-bold text-center text-gray-800">
            NT SSO Authentication
          </h2>
          
          {error && (
            <div className="p-4 text-red-700 bg-red-100 rounded-md border border-red-300">
              <p className="text-sm font-bold">Error:</p>
              <p className="text-sm">{error}</p>
              <p className="mt-2 text-xs">Redirecting to login in 5 seconds...</p>
            </div>
          )}
          
          {success && (
            <div className="p-4 text-green-700 bg-green-100 rounded-md border border-green-300">
              <p className="text-sm">NT SSO authentication successful!</p>
              <p className="mt-2 text-xs">Redirecting to site in 2 seconds...</p>
            </div>
          )}
          
          {!tokenFromUrl && (
            <div className="p-4 text-yellow-700 bg-yellow-100 rounded-md border border-yellow-300">
              <p className="text-sm">Waiting for token from URL parameter...</p>
              <p className="mt-2 text-xs">Current URL: {window.location.href}</p>
            </div>
          )}
          
          {tokenFromUrl && !isLoading && !error && !success && (
            <div className="p-4 text-blue-700 bg-blue-100 rounded-md border border-blue-300">
              <p className="text-sm">Token detected: {tokenFromUrl.substring(0, 20)}...</p>
              <p className="mt-2 text-xs">Check console for detailed logs</p>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default NTSSO